import { Link } from "react-router-dom";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="group inline-flex items-center gap-2.5" aria-label="KinesLima, inicio">
      <span className="relative grid size-9 place-items-center overflow-hidden rounded-xl bg-gradient-to-br from-fuchsia-500 to-violet-600 shadow-[0_8px_30px_rgba(236,25,112,.28)]">
        <span className="font-display text-lg font-extrabold text-white">K</span>
        <span className="absolute -bottom-2 -right-2 size-5 rounded-full bg-white/25 blur-sm" />
      </span>
      {!compact && (
        <span className="font-display text-xl font-extrabold tracking-[-0.04em] text-white">
          Kines<span className="text-fuchsia-400">Lima</span>
        </span>
      )}
    </Link>
  );
}
